<template>
  <ModalXL :closeable="true" @abort="closeModal">
    <prio-ticket-list v-if="hasTicketIframe" :iframe-url="ticketIframe"/>
  </ModalXL>
</template>

<script>
import ModalXL from '@/components/modal/ModalXL.vue'
// import PrimaryButton from "@/components/buttons/PrimaryButton";
import PrioTicketList from "../prioticket/PrioTicketList";
import {hasMetaValue, getMetaValue} from "../../utils";


export default {
  computed: {
    currentUser () {
      return this.$store.getters.currentUser
    },
    membership () {
      return this.currentUser && this.currentUser.membership
    },
    membershipValid() {
      return this.currentUser && this.currentUser.membership && this.currentUser.membership.valid
    },
    membershipType() {
      return this.membership && this.membership.membershipType
    },
    hasTicketIframe() {
      return this.membershipValid && this.membershipType && hasMetaValue(this.membershipType.metaValues, 'ticket-iframe');
    },
    ticketIframe() {
      return this.membershipType && getMetaValue(this.membershipType.metaValues, 'ticket-iframe');
    },
  },
  methods: {
    closeModal() {
      this.$router.push({ path: '/' })
    },
  },
  components: {
    // PrimaryButton,
    ModalXL,
    PrioTicketList,
  }
}
</script>

<style lang="scss" scoped></style>

